import * as React from 'react';
import { Button, ButtonProps } from 'semantic-ui-react';
import classnames from 'classnames';

// Styles
import './styles.scss';

interface Props {
    children?: React.ReactNode | string | number;
    color?: 'grey' | 'black';
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
    buttonProps?: ButtonProps;
    classNames?: string;
}

const ButtonLink = ({
    children,
    color,
    onClick,
    buttonProps = {},
    classNames = ''
}: Props): React.ReactElement | null => {
    if (!children) {
        return null;
    }

    return (
        <Button
            basic
            color={color}
            className={classnames('link', classNames)}
            compact
            {...buttonProps}
            onClick={onClick}
        >
            {children}
        </Button>
    );
};

export default ButtonLink;
